
import TableList from "@components/templates/tablelist";
import {
    HttpTransferOutboundList,
    HttpTransferOutboundConfirm,
    HttpTransferOutboundCancel,
    HttpTransferAdminWarehouseList
} from "@/service/transferplan";
import { mapState, mapGetters } from "vuex";
import compAdd from "./add";
import compUpdate from "./update";
import ajaxjMixin from "../ajaxmixin";
import mixin from "../mixin";
export default {
    mixins: [TableList, mixin, ajaxjMixin],
    components: {
        compAdd,
        compUpdate
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            queryWarehouseList: []
        };
    },
    created() {
        this.getMixinWarehouse(true);
        HttpTransferAdminWarehouseList().then(res => {
            // console.log('res', res);
            this.queryWarehouseList = res.data.map(item => {
                return {
                    value: item.code,
                    label: item.title ? `${item.code}(${item.title})` : item.code,
                    attach: {
                        ...item
                    }
                };
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    methods: {
        ajaxRequest: HttpTransferOutboundList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            // console.log(type);
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        title: "添加",
                        width: 900,
                        component: "compAdd",
                        showFooter: false
                    }
                    break;
                case "edit":
                    {
                        let url = this.$router.resolve({
                            name: 'transferPlanOutboundUpdate',
                            params: { type: "edit" },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                    }
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    {
                        let url = this.$router.resolve({
                            name: "transferPlanOutboundUpdate",
                            params: { type: "query" },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                    }
                    break;
                case "confirm":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "确认",
                        width: 460,
                        showDesc: false,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 22,
                                labelWidth: 100,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false
                            }
                        ],
                        ajaxRequest: HttpTransferOutboundConfirm,
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        showDesc: false,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 22,
                                labelWidth: 100,
                                label: "取消原因",
                            }
                        ],
                        ajaxRequest: HttpTransferOutboundCancel,
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransitOutbound/batchExport",
                        {
                            ...this.formData
                        }
                        , {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error(err.message);
                        })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: this.handleAuth('fbb.transfer.outboundview'),
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: status == 0 && this.handleAuth('fbb.transfer.outboundedit'),
                    params: id,
                    operate: 'edit'
                },
                {
                    label: "确认",
                    show: status == 0 && this.handleAuth('fbb.transfer.outboundedit'),
                    params: id,
                    operate: "confirm"
                },
                {
                    label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    show: status == 0 && this.handleAuth('fbb.transfer.outboundedit'),
                    params: id,
                    operate: 'cancel'
                },]
        },
        getOrderStatus(typeid) {
            let json = this.queryOrderStatusList.filter(item => {
                return item.value == typeid
            })
            return <span class={json[0].color}>{json[0].label}</span>
        },
        getLogisticsStatus(logid) {
            let logjson = this.logisticsStatusList.filter(item => {
                return item.value == logid
            })
            return <span class={logjson[0].color}>{logjson[0].label}</span>
        },
        getExceptionStatus(exceptid) {
            let excepjson = this.exceptionStatus.filter(item => {
                return item.value == exceptid
            })
            if (excepjson[0].label === this.$t('fbb.headlogistics.no_exceptioin', { defaultValue: '无异常' })) {
                return
            }
            return <span class={excepjson[0].color}>{excepjson[0].label}</span>
        },
        getTicketStatus(type) {
            let statusItem = this.ticketStatus.filter(item => {
                return item.value === type
            })[0]
            if (!statusItem) {
                return <span>--</span>
            }
            return <span class={statusItem.color}>{statusItem.label}</span>
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getSystemPortList', 'getCompanyList', 'getFilterDisabledWarehouse']),
        choseOrderStatusList() {
            return this.orderStatusList.filter(item => {
                return item.value != 10
            })
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                    show: this.handleAuth('fbb.transfer.outboundedit')
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    show: this.handleAuth('fbb.transfer.outboundexport'),
                    operate: 'export',
                    theme: 'primary'
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: '转运出库单号',
                    tag: 'vInput',
                    key: 'EQ_transitOutboundOrderNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: '来源单号',
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: "转运计划单号",
                    tag: "vInput",
                    key: "EQ_transitPlanOrderNo",
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: "状态",
                    tag: "vSelect",
                    options: this.getBoundStatus,
                    props: {
                        multiple: true
                    },
                    key: "IN_status",
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: '仓库',
                    key: 'IN_orgWarehouseCode',
                    tag: 'Select',
                    options: this.queryWarehouseList,
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'IN_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    // default:this.initData,
                    props: {
                        // options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: "客户",
                    tag: "Select",
                    options: this.getSelfmanageorgList,
                    key: "IN_organizationId",
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    style: widthStyle
                }
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                    // fixed: 'left'
                },
                {
                    title: "客户",
                    key: "organizationId",
                    render: (h, { row }) => {
                        let orgItem = this.getSelfmanageorgList.filter(item => {
                            return item.value == row.organizationId
                        })[0];
                        return <div>{orgItem ? orgItem.label : "--"}</div>
                    }
                },
                {
                    title: '转运出库单',
                    sortable: true,
                    // fixed: 'left',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.transitOutboundOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: "来源单号",
                    key: "sourceNo",
                    render: (h, { row }) => {
                        return <div>{row.sourceNo || "--"}</div>
                    }
                },
                {
                    title: "转运计划单号",
                    key: "transitPlanOrderNo"
                },
                {
                    title: '状态',
                    render: (h, { row }) => {
                        let statusItem = this.getBoundStatus.filter(item => {
                            return item.value == row.status;
                        })[0];
                        return <div>{statusItem ? statusItem.label : "--"}</div>
                    }
                },
                {
                    title: "仓库",
                    render: (h, { row }) => {
                        let warehouseItem = this.mixinWarehouseList.filter(item => {
                            return item.value == row.orgWarehouseId
                        })[0];
                        return <div>{warehouseItem ? warehouseItem.label : "--"}</div>
                    }
                },
                {
                    title: '项目',
                    render: (h, { row }) => {
                        let lineItem = this.getCusproductList.filter(item => {
                            return item.value == row.lineId;
                        })[0];
                        return <div>
                            <div>{lineItem ? lineItem.label : '--'}</div>
                        </div>
                    }
                },
                {
                    // title: '负责人/更新时间',
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    width: 180
                },
            ];
        },

    },

};
